import React, {useEffect} from 'react';
import {useOrientationLock} from '../../hooks/visuals/useOrientationLock';
import './OrientationLockOverlay.css';

// Блокировка ориентации на мобильных: manifest.json задает "portrait-primary"
// для установленного PWA (Android), но обычная открытая в браузере SPA-вкладка
// его не учитывает — там держим вертикальную ориентацию этим оверлеем
// (screen.orientation.lock() вне полноэкранного/standalone режима почти нигде
// не работает, поэтому тут это best-effort попытка, а не основной механизм).
function OrientationLockOverlay() {
  // Медиазапрос в CSS сам по себе повернутый телефон не отличает ни от
  // вертикального с открытой клавиатурой, ни от планшета — решают системная
  // ориентация и размер экрана (см. checkIfOrientationLockActive)
  const isOrientationLockActive = useOrientationLock();

  useEffect(() => {
    const orientation = window.screen?.orientation;
    orientation?.lock?.('portrait').catch(() => {
    });
  }, []);

  if (!isOrientationLockActive) {
    return null;
  }

  return (
    <div className="orientation-lock-overlay">
      <div className="orientation-lock-icon">📱</div>
      <p className="orientation-lock-text">
        Поверните устройство в вертикальное положение
      </p>
    </div>
  );
}

export default OrientationLockOverlay;
